import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { DEFAULT_PRICE_CURRENCY } from "shared/constants/app-constants"
import { exists } from "shared/lib/exists"
import { formatPrice } from "shared/lib/priceUtils"

interface UseFormattedPriceProps {
  price: number | null | undefined
  currency?: string
  isComplete?: boolean
}

export function useFormattedPrice({
  price,
  currency = DEFAULT_PRICE_CURRENCY,
  isComplete = true
}: UseFormattedPriceProps) {
  const { t } = useTranslation()
  const formattedPrice = useMemo(() => {
    if (exists(price)) {
      return formatPrice({
        price,
        currency,
        prefix: !isComplete ? t("Price.PriceFrom") : null
      })
    }
    return t("Price.NoPriceAvailable")
  }, [price])

  return {
    formattedPrice
  }
}
